import { collection, getDocs, getDoc, doc } from 'firebase/firestore';
import { db } from '../config/firebase';
import { buildAppleSubscribers, AppleSubscriberRow } from '../utils/appleSubscribers';

/**
 * Lista os assinantes Apple identificados lendo os subdocs `subscription/current`
 * de cada usuário (client-readable pelas regras). É a única fonte com identidade
 * de quem renovou: o relatório agregado da Apple não revela o comprador.
 */
export const getAppleSubscribers = async (): Promise<AppleSubscriberRow[]> => {
  const usersSnap = await getDocs(collection(db, 'users'));

  const pairs = await Promise.all(
    usersSnap.docs.map(async (userDoc) => {
      const userData = userDoc.data();
      try {
        const subSnap = await getDoc(doc(db, 'users', userDoc.id, 'subscription', 'current'));
        if (!subSnap.exists()) return null;
        return {
          user: { id: userDoc.id, email: userData.email, name: userData.name, displayName: userData.displayName },
          sub: subSnap.data(),
        };
      } catch {
        return null;
      }
    })
  );

  return buildAppleSubscribers(pairs.filter((p): p is NonNullable<typeof p> => p !== null));
};
